module.exports = __webpack_public_path__ + "img/lawissue1.f0473b37.png";